import React, { useState, useEffect, useMemo } from 'react';
import {object, func, bool, string} from 'prop-types';
import {CloneObject, GetMeses} from '../../../utils/helpers';
import { useForm } from '@laramie/ui';
import { DatePickerCustom, InputEjercicio, InputFormula, InputNumber, ToolbarFormula, Accordion, FormLabel, Select, FormError } from '../../common';
import {isValidNumber, validateFormula} from '../../../utils/validator';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import Modal from '../../common/Modal';
import {TIPS} from "../../../consts/tips";

const EmisionCuotaModal = (props) => {

    const entityInit = {
        id: 0,
        idEmisionDefinicion: 0,
        cuota: 0,
        mes: 0,
        descripcion: "",
        formulaCondicion: "",
        anioTabla: "",
        mesTabla: 0,
        anioDDJJ: "",
        mesDDJJ: 0,
        fechaVencimiento1: null,
        fechaVencimiento2: null,
        fechaVencimiento1Original: null,
        fechaVencimiento2Original: null,
        fechaVencimiento1Masivo: null,
        fechaVencimiento2Masivo: null,
        orden: 0
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        listVariables: [],
        listFunciones: []
    });

    const [cabeceraOpen, setCabeceraOpen] = useState(true);

    const [formulaOpen, setFormulaOpen] = useState(false);

    const [toolbar, setToolbar] = useState({
        show: false,
        horizontal: false
    });

    const [editor, setEditor] = useState({
        fontSize: "md",
        expand: false
    });

    const [queueEvents, setQueueEvents] = useState({
        timestamps: null,
        queue: []
    });

    const mount = () => {
        setState(prevState => {
            return {
                ...prevState,
                entity: props.data.entity,
                listVariables: props.data.listVariables,
                listFunciones: props.data.listFunciones,
                procesaRubros: props.procesaRubros
            };
        });
        formSet({
            cuota: props.data.entity.cuota,
            mes: props.data.entity.mes,
            descripcion: props.data.entity.descripcion,
            formulaCondicion: props.data.entity.formulaCondicion,
            anioTabla: props.data.entity.anioTabla,
            mesTabla: props.data.entity.mesTabla,
            anioDDJJ: props.data.entity.anioDDJJ,
            mesDDJJ: props.data.entity.mesDDJJ,
            fechaVencimiento1: props.data.entity.fechaVencimiento1,
            fechaVencimiento2: props.data.entity.fechaVencimiento2,
            fechaVencimiento1Original: props.data.entity.fechaVencimiento1Original,
            fechaVencimiento2Original: props.data.entity.fechaVencimiento2Original,
            fechaVencimiento1Masivo: props.data.entity.fechaVencimiento1Masivo,
            fechaVencimiento2Masivo: props.data.entity.fechaVencimiento2Masivo,
            orden: props.data.entity.orden
        });
    }
    useEffect(mount, [props.data.entity, props.procesaRubros]);

    const esConDDJJ = useMemo(() =>
            (state.procesaRubros || state.listVariables && state.listVariables.some(x => x.esConDDJJ)),
        [state.procesaRubros, state.listVariables]);

    const [formValues, formHandle, , formSet] = useForm({
        cuota: 0,
        mes: 0,
        descripcion: "",
        formulaCondicion: "",
        anioTabla: "",
        mesTabla: 0,
        anioDDJJ: "",
        mesDDJJ: 0,
        fechaVencimiento1: null,
        fechaVencimiento2: null,
        orden: 0
    });

    //handles
    const handleToolbarFormulaToogleHorizontal = (horizontal) => {
        setToolbar(prevState => {
            return {...prevState, horizontal: horizontal};
        });
    }
    const handleToolbarFormulaSelect = (event) => {
        const timestamps = new Date();
        let newQueue = queueEvents.queue.slice();
        newQueue.push({queueName: "Cuota", timestamps: timestamps, ...event});

        setQueueEvents({
            queue: newQueue,
            timestamps: timestamps
        });
    }

    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickConfirm = () => {
        const errors = getErrors();
        if (errors.cuota || errors.mes || errors.mesTabla || errors.anioTabla || errors.mesDDJJ || errors.anioDDJJ || errors.orden || errors.descripcion || errors.fechaVencimiento1 || errors.fechaVencimiento2) setCabeceraOpen(true);
        if (errors.formulaCondicion) setFormulaOpen(true);

        if (validate()) {

            let row = CloneObject(state.entity);
            row.cuota = formValues.cuota;
            row.mes = parseInt(formValues.mes);
            row.descripcion = formValues.descripcion;
            row.formulaCondicion = formValues.formulaCondicion;
            row.anioTabla = formValues.anioTabla;
            row.mesTabla = parseInt(formValues.mesTabla);
            row.anioDDJJ = formValues.anioDDJJ;
            row.mesDDJJ = parseInt(formValues.mesDDJJ);
            row.fechaVencimiento1 = formValues.fechaVencimiento1;
            row.fechaVencimiento2 = formValues.fechaVencimiento2;
            row.fechaVencimiento1Original = formValues.fechaVencimiento1;
            row.fechaVencimiento2Original = formValues.fechaVencimiento2;
            row.fechaVencimiento1Masivo = null;
            row.fechaVencimiento2Masivo = null;
            row.orden = parseInt(formValues.orden);

            props.onConfirm(row);
        }
        ;
    }

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.orden.toString().length <= 0) errors.orden = VALIDATION_MESSAGE.REQUIRED_SHORT;
        else if (formValues.orden <= 0) errors.orden = 'Ingresá un número mayor a cero';
        if (!isValidNumber(formValues.cuota, true)) errors.cuota = 'Ingresá un número mayor a cero';
        if (formValues.mes <= 0) errors.mes = VALIDATION_MESSAGE.REQUIRED_SHORT;

        if (formValues.anioTabla.length <= 0) errors.anioTabla = VALIDATION_MESSAGE.REQUIRED_SHORT;
        else if (formValues.anioTabla.length < 4) errors.anioTabla = 'Ingresá 4 dígitos';
        if (formValues.mesTabla <= 0) errors.mesTabla = VALIDATION_MESSAGE.REQUIRED_SHORT;

        if (formValues.descripcion.length <= 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.fechaVencimiento1 == null) errors.fechaVencimiento1 = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (formValues.fechaVencimiento2 == null) errors.fechaVencimiento2 = VALIDATION_MESSAGE.REQUIRED_DATE;

        if (esConDDJJ) {
            if (formValues.anioDDJJ.length <= 0) errors.anioDDJJ = VALIDATION_MESSAGE.REQUIRED_SHORT;
            else if (formValues.anioDDJJ.length < 4) errors.anioDDJJ = 'Ingresá 4 dígitos';
            if (formValues.mesDDJJ <= 0) errors.mesDDJJ = VALIDATION_MESSAGE.REQUIRED_SHORT;
        }

        if (formValues.formulaCondicion.length > 0) {
            const error = validateFormula(formValues.formulaCondicion);
            if (error) errors.formulaCondicion = `Fórmula incorrecta: ${error}`;
        }

        return errors;
    }

    function ToggleFormulaExpand() {
        if (!editor.expand && cabeceraOpen) {
            setCabeceraOpen(false);
        }
        setEditor(prevState => {
            return {...prevState, expand: !prevState.expand};
        });
    }

    function SetFormulaFontSizeUp() {
        let fontSize = editor.fontSize;
        if (fontSize === "xm") fontSize = "sm";
        else if (fontSize === "sm") fontSize = "md";
        else if (fontSize === "md") fontSize = "lg";

        if (fontSize !== editor.fontSize) {
            setEditor(prevState => {
                return {...prevState, fontSize: fontSize};
            });
        }
    }

    function SetFormulaFontSizeDown() {
        let fontSize = editor.fontSize;
        if (fontSize === "lg") fontSize = "md";
        else if (fontSize === "md") fontSize = "sm";
        else if (fontSize === "sm") fontSize = "xm";

        if (fontSize !== editor.fontSize) {
            setEditor(prevState => {
                return {...prevState, fontSize: fontSize};
            });
        }
    }

    function ToogleToolbarShow() {
        setToolbar(prevState => {
            return {
                show: !prevState.show,
                horizontal: false
            };
        });
    }

    return (
        <>

            <Modal
                size={(toolbar.show && !toolbar.horizontal) ? "xl" : "lg"}
                title={`Cuota: ${(state.entity.id > 0) ? state.entity.descripcion : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.EMISION_CUOTA_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div id="panel-main"
                                     className={(toolbar.show && !toolbar.horizontal) ? "col-12 col-lg-8" : "col-12"}>

                                    <Accordion title="Datos" open={cabeceraOpen} onToggle={setCabeceraOpen}>
                                        <div className="row form-basic">
                                            <div className="col-12 col-md-6 col-lg-2">
                                                <FormLabel htmlFor="cuota" required>Cuota</FormLabel>
                                                <InputNumber
                                                    name="cuota"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('cuota') ? 'is-invalid' : ''}`}
                                                    value={formValues.cuota}
                                                    precision={0}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('cuota')} />
                                            </div>

                                            <div className="col-12 col-md-6 col-lg-2">
                                                <FormLabel htmlFor="mes" required>Mes cuota</FormLabel>
                                                <Select
                                                    name="mes"
                                                    className={`form-control ${errorOf('mes') ? 'is-invalid' : ''}`}
                                                    value={formValues.mes}
                                                    options={GetMeses().map(item => ({value: item.key, label: item.name}))}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('mes')} />
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-2">
                                                <label htmlFor="anioTabla" className="form-label">Año cuota</label>
                                                <InputEjercicio
                                                    name="periodo"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={props.periodo ?? ""}
                                                    disabled={true}
                                                />
                                                <FormError />
                                            </div>

                                            <div className="col-12 col-md-6 col-lg-2">
                                                <FormLabel htmlFor="mesTabla" required>Mes tabla</FormLabel>
                                                <Select
                                                    name="mesTabla"
                                                    className={`form-control ${errorOf('mesTabla') ? 'is-invalid' : ''}`}
                                                    value={formValues.mesTabla}
                                                    options={GetMeses().map(item => ({value: item.key, label: item.name}))}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('mesTabla')} />
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-2">
                                                <FormLabel htmlFor="anioTabla" required>Año tabla</FormLabel>
                                                <InputEjercicio
                                                    name="anioTabla"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('anioTabla') ? 'is-invalid' : ''}`}
                                                    value={formValues.anioTabla}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('anioTabla')} />
                                            </div>

                                            {esConDDJJ &&
                                                <>
                                                    <div className="col-12 col-md-6 col-lg-2">
                                                        <FormLabel htmlFor="mesDDJJ" required>Mes
                                                            DDJJ</FormLabel>
                                                        <Select
                                                            name="mesDDJJ"
                                                            className={`form-control ${errorOf('mesDDJJ') ? 'is-invalid' : ''}`}
                                                            value={formValues.mesDDJJ}
                                                            options={GetMeses().map(item => ({value: item.key, label: item.name}))}
                                                            onChange={formHandle}
                                                            disabled={props.disabled}
                                                        />
                                                        <FormError message={errorOf('mesDDJJ')} />
                                                    </div>
                                                    <div className="col-12 col-md-6 col-lg-2">
                                                        <FormLabel htmlFor="anioDDJJ" required>Año
                                                            DDJJ</FormLabel>
                                                        <InputEjercicio
                                                            name="anioDDJJ"
                                                            placeholder=""
                                                            className={`form-control ${errorOf('anioDDJJ') ? 'is-invalid' : ''}`}
                                                            value={formValues.anioDDJJ}
                                                            onChange={formHandle}
                                                            disabled={props.disabled}
                                                        />
                                                        <FormError message={errorOf('anioDDJJ')} />
                                                    </div>
                                                </>
                                            }
                                            <div className="col-12 col-md-6 col-lg-2">
                                                <FormLabel htmlFor="orden" required>Orden</FormLabel>
                                                <input
                                                    name="orden"
                                                    type="number"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
                                                    value={formValues.orden}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('orden')} />
                                            </div>
                                            <div className={`col-12 col-md-6 ${esConDDJJ ? 'col-lg-8' : 'col-lg-4'}`}>
                                                <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                                                <input
                                                    name="descripcion"
                                                    type="text"
                                                    placeholder=""
                                                    maxLength={1000}
                                                    className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                                                    value={formValues.descripcion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('descripcion')} />
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-4">
                                                <FormLabel htmlFor="fechaVencimiento1" required>Primer
                                                    vencimiento</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaVencimiento1"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaVencimiento1') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaVencimiento1}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fechaVencimiento1')} />
                                            </div>
                                            <div className="col-12 col-md-6 col-lg-4">
                                                <FormLabel htmlFor="fechaVencimiento2" required>Segundo
                                                    vencimiento</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaVencimiento2"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaVencimiento2') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaVencimiento2}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    minValue={formValues.fechaVencimiento1}
                                                />
                                                <FormError message={errorOf('fechaVencimiento2')} />
                                            </div>
                                        </div>
                                    </Accordion>

                                    <Accordion
                                        title="Condición"
                                        className="m-top-15 invisible"
                                        open={formulaOpen}
                                        onToggle={setFormulaOpen}
                                        actions={
                                            <div className="action m-right-20 m-top-10">
                                                {!props.disabled && !toolbar.show &&
                                                    <div onClick={(event) => ToogleToolbarShow()}
                                                         className="link float-end m-left-5">
                                                        <span className="material-symbols-outlined"
                                                              title="Mostrar asistente de fórmulas">function</span>
                                                    </div>
                                                }
                                                <div onClick={(event) => ToggleFormulaExpand()}
                                                     className="link float-end m-left-5">
                                                    {(editor.expand) ? <span className="material-symbols-outlined"
                                                                             title="Contraer editor de fórmula">zoom_in_map</span> :
                                                        <span className="material-symbols-outlined"
                                                              title="Expandir editor de fórmula">zoom_out_map</span>}
                                                </div>
                                                <div onClick={(event) => SetFormulaFontSizeDown()}
                                                     className="link float-end m-left-5">
                                                    <span className="material-symbols-outlined"
                                                          title="Disminuir tamaño de fuente">text_decrease</span>
                                                </div>
                                                <div onClick={(event) => SetFormulaFontSizeUp()}
                                                     className="link float-end m-left-5">
                                                    <span className="material-symbols-outlined"
                                                          title="Aumentar tamaño de fuente">text_increase </span>
                                                </div>
                                            </div>
                                        }
                                    >
                                        <div className="row">
                                            <div className="col-12">
                                                <InputFormula
                                                    name="formulaCondicion"
                                                    className={`form-control ${errorOf('formulaCondicion') ? 'is-invalid' : ''}`}
                                                    fontSize={editor.fontSize}
                                                    editorExpanded={editor.expand}
                                                    value={formValues.formulaCondicion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    data={{
                                                        listCalculos: [],
                                                        listVariables: state.listVariables,
                                                        listFunciones: state.listFunciones,
                                                        listParametros: [],
                                                        listElementos: [],
                                                        listTiposDeclaracionJurada: []
                                                    }}
                                                    queueEvents={queueEvents}
                                                    queueName="Cuota"
                                                />
                                                <FormError message={errorOf('formulaCondicion')} />
                                            </div>
                                        </div>
                                    </Accordion>

                                </div>

                                {toolbar.show &&
                                    <ToolbarFormula
                                        data={{
                                            listCalculos: [],
                                            listVariables: state.listVariables,
                                            listFunciones: state.listFunciones,
                                            listParametros: [],
                                            listElementos: [],
                                            listTiposDeclaracionJurada: []
                                        }}
                                        showCalculo={false}
                                        showParametros={false}
                                        showElementos={false}
                                        showEntidades={false}
                                        onToogleHorizontal={handleToolbarFormulaToogleHorizontal}
                                        onSelect={handleToolbarFormulaSelect}
                                        onClose={ToogleToolbarShow}
                                    />
                                }

                            </div>
                )}
                footerClassName="modal-footer-unset"
                footer={(<>
                            {!props.disabled && <>
                                <button className="btn btn-primary float-end" data-dismiss="modal"
                                        onClick={(event) => handleClickConfirm()}>Aceptar
                                </button>
                                <button className="btn btn-outline-primary float-end" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                            </>}

                            {props.disabled &&
                                <div className="width-100p f-align">
                                    <button className="btn back-button float-start" data-dismiss="modal"
                                            onClick={(event) => props.onDismiss()}>Volver
                                    </button>
                                </div>
                            }
                </>)}
            />

        </>
    );
}

EmisionCuotaModal.propTypes = {
    disabled: bool,
    disabledDates: bool,
    data: object.isRequired,
    periodo: string.isRequired,
    procesaRubros: bool.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired
};

EmisionCuotaModal.defaultProps = {
    disabled: false,
    disabledDates: false
};

export default EmisionCuotaModal;